<style scoped>
.border {
  padding: 10px;
  border: 1px solid grey;
  border-radius: 5px;
}
</style>

<template>
  <v-row justify="center" align="center">
    <v-col xl="8" lg="8" md="10" sm="12">
      <v-stepper v-model="stepnow" vertical>
        <v-card flat class="text-center transparent pa-2">
          <span class="title primary--text text--darken-2">
            <strong>
              {{ $t('council_license_application') }}
            </strong>
          </span>
        </v-card>

        <!-- application -->
        <v-stepper-step :complete="stepnow > 1" step="1" @click.native="stepnow = 1">
          {{ $t('applicant_information') }}
        </v-stepper-step>

        <v-stepper-content step="1">
          <v-card class="mb-12" flat>
            <v-form ref="form1" v-model="valid" lazy-validation>
              <v-row no-gutters align="center" class="text-center">
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-text-field clearable name="name" v-model="data.applicant.name" :label="$t('name', { field: $t('applicant') }) + ' *'" :rules="[rules.required]" required type="text"></v-text-field>
                </v-col>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-text-field clearable name="identity_no" maxLength="14" :value="icFormat(data.applicant.identity_no)" @input="data.applicant.identity_no = $event" :label="$t('identity_no', { field: $t('applicant') }) + ' *'" :rules="[rules.required, rules.nricLength, rules.dateOfBirth]" required type="text"></v-text-field>
                </v-col>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-select clearable name="citizenship" v-model="data.applicant.citizenship" :label="$t('citizenship') + ' *'" :rules="[rules.required]" :items="citizenship"></v-select>
                </v-col>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-select clearable name="gender" v-model="data.applicant.gender" :label="$t('gender') + ' *'" :items="gender" :rules="[rules.required]" :item-text="opt => $t(opt.value).toUpperCase()" :item-value="opt => opt.value"></v-select>
                </v-col>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-select clearable name="religion" v-model="data.applicant.religion" :label="$t('religion') + ' *'" :items="religion" :rules="[rules.required]"></v-select>
                </v-col>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-select clearable name="race" v-model="data.applicant.race" :label="$t('race') + ' *'" :items="race" :rules="[rules.required]"></v-select>
                </v-col>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-select clearable name="marital_status" v-model="data.applicant.marital_status" :label="$t('marital_status') + ' *'" :rules="[rules.required]" :item-text="opt => $t(opt.text)" :item-value="opt => opt.value" :items="marital_status"></v-select>
                </v-col>
                <v-col cols="12">
                  <v-textarea clearable name="mailing_address" v-model="data.applicant.mailing_address" :label="$t('mailing_address') + ' *'" :rules="[rules.required]" required type="text"></v-textarea>
                </v-col>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-text-field clearable name="mail_postcode" v-model="data.applicant.mail_postcode" :label="$t('postcode') + ' *'" :rules="[rules.required]" required type="text"></v-text-field>
                </v-col>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-select clearable name="mail_state" v-model="data.applicant.mail_state" :label="$t('state') + ' *'" :rules="[rules.required]" :items="states" :item-text="opt => opt" :item-value="opt => opt"></v-select>
                </v-col>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-select clearable name="mail_city" v-model="data.applicant.mail_city" :label="$t('city') + ' *'" :items="cities[data.applicant.mail_state]" :rules="[rules.required]" :item-text="opt => opt" :item-value="opt => opt"></v-select>
                </v-col>
                <v-col cols="12">
                  <v-switch name="sameAsMail" class="mt-4" :label="$t('same_as_mail')" v-model="data.applicant.sameAsMail" @change="onSameMailChanged"></v-switch>
                </v-col>
                <v-col cols="12">
                  <v-textarea clearable name="residential_address" :rules="[rules.required]" v-model="data.applicant.residential_address" :label="$t('residential_address') + ' *'" required type="text"></v-textarea>
                </v-col>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-text-field clearable name="postcode" v-model="data.applicant.postcode" :label="$t('postcode') + ' *'" :rules="[rules.required]" required type="text"></v-text-field>
                </v-col>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-select clearable name="state" v-model="data.applicant.state" :label="$t('state') + ' *'" :rules="[rules.required]" :items="states" :item-text="opt => opt" :item-value="opt => opt"></v-select>
                </v-col>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-select clearable name="city" v-model="data.applicant.city" :label="$t('city') + ' *'" :rules="[rules.required]" :items="cities[data.applicant.state]" :item-text="opt => opt" :item-value="opt => opt"></v-select>
                </v-col>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-text-field clearable maxLength="11" name="mobile_tel" v-model="data.applicant.mobile_tel" :rules="[rules.required]" :label="$t('mobile_tel') + ' *'" required type="tel"></v-text-field>
                </v-col>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-text-field clearable maxLength="11" name="office_tel" v-model="data.applicant.office_tel" :label="$t('office_tel')" required type="tel"></v-text-field>
                </v-col>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-text-field clearable maxLength="11" name="residential_tel" v-model="data.applicant.residential_tel" :label="$t('residential_tel')" required type="tel"></v-text-field>
                </v-col>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-text-field clearable name="email" v-model="data.applicant.email" :label="$t('email', { field: $t('applicant') }) + ' *'" type="email" :rules="[rules.required, rules.email]" required></v-text-field>
                </v-col>
              </v-row>
              <div class="text-right">
                <v-btn color="primary" @click="changeStep(`form1`, stepnow + 1)">{{ $t('continue') }}</v-btn>
              </div>
            </v-form>
          </v-card>
        </v-stepper-content>

        <!-- license info -->
        <v-stepper-step :complete="stepnow > 2" step="2" @click.native="stepnow > 1 ? stepnow = 2 : null">
          {{ $t('license_information') }}
        </v-stepper-step>

        <v-stepper-content step="2">
          <v-card flat class="mb-12">
            <v-form ref="form2" v-model="valid" lazy-validation>
              <v-select name="license_type" :items="licenseTypes" @change="onLicenseTypeChanged" :item-text="opt => opt.label" :item-value="opt => opt.value" v-model="data.license.type" :label="$t('license_type')" :rules="[rules.required]"></v-select>
              <v-text-field v-if="data.license.type !== 'license_dog'" clearable :rules="data.license.type === 'license_operating' ? [rules.required] : undefined" name="trading_no" placeholder="RXXXX" v-model="data.license.trading_no" :label="data.license.type === 'license_operating' ? $t('trading_no') : `${$t('trading_no')} (${$t('optional')})`" required type="text"></v-text-field>
              <v-select v-if="data.license.type === 'license_operating'" name="business_category" :rules="[rules.required]" :items="categories" :item-text="opt => opt.businesstype" :item-value="opt => opt" @change="onOperationCategoryChanged" v-model="data.license.category" :label="$t('business_category')"></v-select>
              <v-select v-if="data.license.type === 'license_operating'" name="business_subcategory" :rules="[rules.required]" :items="business_zones" :item-text="opt => opt.businesstype" :item-value="opt => opt" @change="onOperationSubcategoryChanged" v-model="data.license.subcategory" :label="$t('business_subcategory')"></v-select>
              <v-row v-if="data.license.type === 'license_operating' && Number(data.license.subcategory.licensefee) > 0" justify="space-between" align="center">
                <v-col>
                  <v-text-field name="quantity" :rules="[rules.required, rules.minimumValue]" v-model="data.license.quantity" :label="$t('quantity')" required type="tel"></v-text-field>
                </v-col>
                <v-col>
                  <div class="text-subtitle2" v-if="data.license.type === 'license_operating' && data.license.subcategory !== ''">
                    <span class="text-h5">{{ data.license.subcategory.unitcharge }}</span> MYR / {{ $t("unit") }}
                  </div>
                </v-col>
              </v-row>
              <v-select v-if="data.license.type === 'license_hawker'" name="business_zone" :rules="[rules.required]" :items="business_zones" :item-text="opt => opt.name" :item-value="opt => opt" v-model="data.license.business_zone" :label="$t('business_zone')"/>
              <v-select v-if="data.license.type === 'license_market'" name="market" :rules="[rules.required]" :items="markets" @change="onMarketChanged" :item-text="opt => opt.name" :item-value="opt => opt" v-model="data.license.market" :label="$t('market')"/>
              <v-select v-if="data.license.type === 'license_market'" name="market_zone" :rules="[rules.required]" :items="business_zones" :item-text="opt => opt.name" :item-value="opt => opt" v-model="data.license.market_zone" :label="$t('market_zone')"/>
              <v-text-field v-if="data.license.type === 'license_market'" clearable :rules="[rules.required]" name="lot_quantity" v-model="data.license.lot_quantity" :label="$t('lot_quantity')" required type="number"></v-text-field>
              <v-text-field v-if="data.license.type === 'license_hawker' || data.license.type === 'license_market'" clearable :rules="[rules.required]" name="sales_type" v-model="data.license.sales_type" :label="$t('sales_type')" required type="text"></v-text-field>
              <v-select v-if="data.license.type === 'license_market'" name="sales_period" :items="salesPeriod" :item-text="opt => opt.label" :item-value="opt => opt.value" v-model="data.license.sales_period" :label="$t('sales_period')" :rules="[rules.required]"></v-select>
              <v-text-field v-if="data.license.type === 'license_hawker'" clearable name="transport_no" v-model="data.license.transport_no" :label="$t('transport_no') + ` (${$t('mobile_hawker')})`" required type="text"></v-text-field>
              <v-text-field v-if="data.license.type === 'license_hawker'" clearable name="lot_no" v-model="data.license.lot_no" :label="$t('lot_no') + ` (${$t('regular_hawker')})`" required type="text"></v-text-field>
              <v-textarea v-if="data.license.type === 'permit_billboard' || data.license.type === 'permit_open_space'" clearable name="location" :rules="[rules.required]" v-model="data.license.location" :label="$t('location')" required type="text"></v-textarea>
              <v-text-field v-if="data.license.type === 'permit_billboard' || data.license.type === 'permit_open_space'" clearable name="business_name" :rules="[rules.required]" v-model="data.license.business_name" :label="$t('business_name')" required type="text"></v-text-field>
              <v-select v-if="data.license.type === 'permit_billboard' || data.license.type === 'permit_open_space'" name="business_type" :rules="[rules.required]" :items="business_zones" @change="onBusinessTypeChanged" :item-text="opt => opt.name" :item-value="opt => opt" v-model="data.license.business_type" :label="$t('business_type')"/>
              <v-row v-if="data.license.type === 'license_dog'">
                <v-col cols="12">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            {{ $t(`gender`) }}
                          </th>
                          <th class="text-right">
                            {{ $t(`rate_per_dog`) }}
                          </th>
                          <th class="text-right">
                            {{ $t(`quantity`) }}
                          </th>
                          <th class="text-right">
                            {{ $t(`subtotal`) }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style="min-width: 200px;">
                            <v-select name="business_charges" :items="business_charges" :item-text="opt => opt.name" :item-value="opt => opt" v-model="business_charge" :label="$t('business_charges') + ' *'"/>
                          </td>
                          <td class="text-right">{{ (business_charge.charge_rate || "-") | ringgit }}</td>
                          <td class="text-right" style="min-width: 200px;">
                            <v-text-field clearable name="quantity" v-model="business_charge.quantity" :label="$t('quantity') + ' *'" required type="tel"></v-text-field>
                          </td>
                          <td class="text-right font-weight-bold text-h6">{{ calculateSubTotal(business_charge) | ringgit }}</td>
                          <td>
                            <v-btn rounded icon color="primary" @click="addCharge">
                              <v-icon>fa-plus</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        <tr
                          v-for="(item, index) in data.license.business_charges"
                          :key="item._id"
                        >
                          <td>{{ `${item.code} - ${item.name}` }}</td>
                          <td class="text-right" style="min-width: 100px;">{{ item.charge_rate | ringgit }}</td>
                          <td class="text-right" style="min-width: 100px;">{{ item.quantity }}</td>
                          <td class="text-right font-weight-bold text-h6">{{ calculateSubTotal(item) | ringgit }}</td>
                          <td>
                            <v-btn rounded icon color="error" @click="removeCharge(index)">
                              <v-icon>fa-trash</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
              <v-row v-if="data.license.type === 'permit_billboard' || data.license.type === 'permit_open_space'">
                <v-col cols="12">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            {{ $t(`name`) }}
                          </th>
                          <th class="text-right">
                            {{ $t(`rate_per_square_feet`) }}
                          </th>
                          <th class="text-right">
                            {{ $t(`width`) }} ({{ $t("feet") }})
                          </th>
                          <th class="text-right">
                            {{ $t(`length`) }} ({{ $t("feet") }})
                          </th>
                          <th class="text-right">
                            {{ $t(`quantity`) }}
                          </th>
                          <th class="text-right">
                            {{ $t(`subtotal`) }}
                          </th>
                          <th class="text-left">
                            {{ $t(`action`) }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style="min-width: 200px;">
                            <v-select name="business_charges" :items="business_charges" :item-text="opt => opt.name" :item-value="opt => opt" v-model="business_charge" :label="$t('business_charges') + ' *'"/>
                          </td>
                          <td class="text-right">{{ (business_charge.charge_rate || "-") | ringgit }}</td>
                          <td v-if="business_charge.formula_type === 'area'" class="text-right" style="min-width: 200px;">
                            <v-text-field clearable name="width" v-model="business_charge.width" :label="$t('width') + ' *'" required type="tel"></v-text-field>
                          </td>
                          <td v-else class="text-right">-</td>
                          <td v-if="business_charge.formula_type === 'area'" class="text-right" style="min-width: 200px;">
                            <v-text-field clearable name="length" v-model="business_charge.length" :label="$t('length') + ' *'" required type="tel"></v-text-field>
                          </td>
                          <td v-else class="text-right">-</td>
                          <td class="text-right" style="min-width: 200px;">
                            <v-text-field clearable name="quantity" v-model="business_charge.quantity" :label="$t('quantity') + ' *'" required type="tel"></v-text-field>
                          </td>
                          <td class="text-right font-weight-bold text-h6">{{ calculateSubTotal(business_charge) | ringgit }}</td>
                          <td>
                            <v-btn rounded icon color="primary" @click="addCharge">
                              <v-icon>fa-plus</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        <tr
                          v-for="(item, index) in data.license.business_charges"
                          :key="item._id"
                        >
                          <td>{{ `${item.code} - ${item.name}` }}</td>
                          <td class="text-right" style="min-width: 100px;">{{ item.charge_rate | ringgit }}</td>
                          <td class="text-right" style="min-width: 100px;">{{ item.width ? item.width.toFixed(2) : '-' }}</td>
                          <td class="text-right" style="min-width: 100px;">{{ item.length ? item.length.toFixed(2) : '-' }}</td>
                          <td class="text-right" style="min-width: 100px;">{{ item.quantity }}</td>
                          <td class="text-right font-weight-bold text-h6">{{ calculateSubTotal(item) | ringgit }}</td>
                          <td>
                            <v-btn rounded icon color="error" @click="removeCharge(index)">
                              <v-icon>fa-trash</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
                <v-col cols="12" class="text-right" v-if="data.license.type === 'permit_billboard' || data.license.type === 'permit_open_space'">
                  <div class="font-weight-bold text-subtitle2">
                    {{ $t("estimate_price") }} : <span class="text-h4">{{ calculateTotal | ringgit }}</span> MYR
                  </div>
                </v-col>
              </v-row>
              <div class="text-subtitle2" v-if="data.license.type === 'license_operating' && data.license.subcategory !== ''">
                {{ $t("license_fee") }} : <span class="text-h5">{{ data.license.subcategory.licensefee }}</span> MYR
              </div>
              <div class="font-weight-bold text-subtitle2" v-if="data.license.type === 'license_operating' && data.license.subcategory !== ''">
                {{ $t("estimate_price") }} : <span class="text-h4">{{ calculateTotal | ringgit }}</span> MYR / {{ $t(data.license.subcategory.rate) }}
              </div>
              <br /><br />

              <div class="text-right">
                <v-btn outlined color="primary" @click="stepnow = 1">{{ $t('previous') }}</v-btn>
                <v-btn color="primary" @click="submitForm">{{ $t('submit') }}</v-btn>
              </div>
            </v-form>
          </v-card>
        </v-stepper-content>
      </v-stepper>
    </v-col>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-row>
</template>

<script>
/* eslint-disable camelcase */
import axios from 'axios'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import i18n from '../../i18n'
import { cloneDeep, merge, throttle } from 'lodash'

const DEFAULT_FORM_DATA = {
  applicant: {
    name: '',
    identity_type: 'nric',
    identity_no: '',
    citizenship: 'MALAYSIAN - SABAH',
    gender: 'male',
    religion: 'ISLAM',
    race: '',
    marital_status: '',
    mailing_address: '',
    mail_postcode: '',
    mail_city: '',
    mail_state: '',
    sameAsMail: false,
    residential_address: '',
    postcode: '',
    state: '',
    city: '',
    mobile_tel: '',
    office_tel: '',
    residential_tel: '',
    email: ''
  },
  license: {
    type: '',
    location: '',
    market: '',
    market_zone: '',
    category: '',
    quantity: '',
    subcategory: '',
    trading_no: '',
    transport_no: '',
    sales_type: '',
    sales_period: '',
    lot_no: '',
    lot_quantity: '',
    business_name: '',
    business_type: '',
    business_zone: '',
    business_charges: []
  }
}

export default {
  beforeMount: async function () {
    this.loading = true
    await this.resetData()
    await this.fetchCategories()
    if (this.hasSession()) {
      const { name, full_name, phone, ic_num } = this.$store.state.auth.session
      this.patchOwner({ owner: { name: full_name, identity_no: ic_num, identity_type: 'nric', phone, email: name } })
    }
    this.loading = false
  },
  computed: {
    ...mapState({
      categories: (state) => state.licenseForm.categories
    }),
    calculateTotal () {
      if (this.data.license.type === 'license_operating') {
        return ((Number(this.data.license.quantity) * Number(this.data.license.subcategory.unitcharge)) + Number(this.data.license.subcategory.licensefee)) * 100
      }
      if (this.data.license.type !== 'license_dog' || this.data.license.type !== 'permit_billboard' || this.data.license.type === 'permit_open_space') return 0
      return this.data.license.business_charges.reduce((sum, charge) => {
        if (charge.formula_type !== 'area') {
          return sum + (charge.quantity * charge.charge_rate)
        }
        return sum + (charge.quantity * (charge.charge_rate * charge.width * charge.length))
      }, 0)
    },
    salesPeriod () {
      return [
        { label: i18n.t('option_all_day'), value: 'all_day' },
        { label: i18n.t('option_morning'), value: 'morning' },
        { label: i18n.t('option_evening'), value: 'evening' },
        { label: i18n.t('option_night'), value: 'night' }
      ]
    },
    licenseTypes () {
      return [
        { label: i18n.t('license_dog'), value: 'license_dog' },
        // { label: i18n.t('license_hawker'), value: 'license_hawker' },
        // { label: i18n.t('license_market'), value: 'license_market' },
        { label: i18n.t('license_operating'), value: 'license_operating' },
        { label: i18n.t('permit_billboard'), value: 'permit_billboard' },
        { label: i18n.t('permit_open_space'), value: 'permit_open_space' }
      ]
    },
    rules () {
      return {
        dateOfBirth: value => (value && value.length > 6 ? (((parseInt(value.replace(/[\s-]/g, '').substr(4, 2)) < 32 && parseInt(value.replace(/[\s-]/g, '').substr(4, 2)) > 0) && (parseInt(value.replace(/[\s-]/g, '').substr(2, 2)) < 13 && parseInt(value.replace(/[\s-]/g, '').substr(2, 2)) > 0)) || i18n.t('invalidDateOfBirth')) : true),
        required: value => !!value || i18n.t('requiredField'),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || i18n.t('invalidEmailFormat')
        },
        minimumValue: value => Number(value) > 0 || i18n.t('minimumValue', { field: 1 }),
        nricLength: value => (value ? (value.replace(/[\s-]/g, '').length === 12 || i18n.t('invalidNRICFormat')) : true)
      }
    }
  },
  created: async function () {
    await this.$store.dispatch('auth/session')
    if (this.hasSession()) {
      const { name, full_name, phone, ic_num } = this.$store.state.auth.session
      this.patchOwner({ owner: { name: full_name, identity_no: ic_num, identity_type: 'nric', phone, email: name } })
    }
    window.scrollTo(0, 0)
  },
  data () {
    return {
      data: cloneDeep(DEFAULT_FORM_DATA),
      valid: false,
      loading: false,
      stepnow: 1,
      business_zones: [],
      markets: [],
      business_charges: [],
      business_charge: { formula_type: '' },
      marital_status: [
        { text: 'single', value: 'single' },
        { text: 'married', value: 'married' },
        { text: 'widow', value: 'widow' },
        { text: 'widower', value: 'widower' },
        { text: 'single_mother', value: 'single_mother' },
        { text: 'single_father', value: 'single_father' }
      ],
      identity_type: [
        { value: 'nric' },
        { value: 'oldic' },
        { value: 'passport' }
      ],
      gender: [
        { value: 'male' },
        { value: 'female' }
      ],
      citizenship: [
        'MALAYSIAN - SABAH',
        'MALAYSIAN - SARAWAK / SEMENANJUNG MALAYSIA',
        'PEMASTAUTIN / PEMEGANG PERMIT TINGGAL TETAP',
        'OTHERS'
      ],
      religion: [
        'ISLAM',
        'BUDDHIST',
        'CHRISTIAN',
        'HINDU',
        'OTHERS'
      ],
      race: [
        'ARABIAN',
        'BAJAU',
        'BANJAR',
        'BATAK',
        'BISAYA',
        'BOLONGAN',
        'BRUNEI',
        'BUGIS',
        'BUTON',
        'CHINESE',
        'DUSUN',
        'EAU',
        'IBAN',
        'INDIAN',
        'JAWA',
        'KADAZAN',
        'MELAYU',
        'MINANG',
        'MURUT',
        'PAKISTAN',
        'SAB',
        'SIN',
        'SULUK',
        'TATOR',
        'TIDUNG',
        'TIMORESE',
        'TORAJA',
        'VISAYA',
        'OTHERS'
      ],
      states: [
        'JOHOR',
        'KEDAH',
        'KELANTAN',
        'MELAKA',
        'NEGERI SEMBILAN',
        'PAHANG',
        'PERAK',
        'PERLIS',
        'PULAU PINANG',
        'SARAWAK',
        'SELANGOR',
        'TERENGGANU',
        'KUALA LUMPUR',
        'LABUAN',
        'SABAH',
        'PUTRAJAYA'
      ],
      cities: {
        'JOHOR': [
          'JOHOR BAHRU',
          'TEBRAU',
          'PASIR GUDANG',
          'BUKIT INDAH',
          'SKUDAI',
          'KLUANG',
          'BATU PAHAT',
          'MUAR',
          'ULU TIRAM',
          'SENAI',
          'SEGAMAT',
          'KULAI',
          'KOTA TINGGI',
          'PONTIAN KECHIL',
          'TANGKAK',
          'BUKIT BAKRI',
          'YONG PENG',
          'PEKAN NENAS',
          'LABIS',
          'MERSING',
          'SIMPANG RENGGAM',
          'PARIT RAJA',
          'KELAPA SAWIT',
          'BULOH KASAP',
          'CHAAH'
        ],
        'KEDAH': [
          'SUNGAI PETANI',
          'ALOR SETAR',
          'KULIM',
          'JITRA / KUBANG PASU',
          'BALING',
          'PENDANG',
          'LANGKAWI',
          'YAN',
          'SIK',
          'KUALA NERANG',
          'POKOK SENA',
          'BANDAR BAHARU'
        ],
        'KELANTAN': [
          'KOTA BHARU',
          'PANGKAL KAlONG',
          'TANAH MERAH',
          'PERINGAT',
          'WAKAF BARU',
          'KADOK',
          'PASIR MAS',
          'GUA MUSANG',
          'KUALA KRAI',
          'TUMPAT'
        ],
        'MELAKA': [
          'BANDARAYA MELAKA',
          'BUKIT BARU',
          'AYER KEROH',
          'KLEBANG',
          'MASJID TANAH',
          'SUNGAI UDANG',
          'BATU BERENDAM',
          'ALOR GAJAH',
          'BUKIT RAMBAI',
          'AYER MOLEK',
          'BEMBAN',
          'KUALA SUNGAI BARU',
          'PULAU SEBANG'
        ],
        'NEGERI SEMBILAN': [
          'SEREMBAN',
          'PORT DICKSON',
          'NILAI',
          'BAHAU',
          'TAMPIN',
          'KUALA PILAH'
        ],
        'PAHANG': [
          'KUANTAN',
          'TEMERLOH',
          'BENTONG',
          'MENTAKAB',
          'RAUB',
          'JERANTUT',
          'PEKAN',
          'KUALA LIPIS',
          'BANDAR JENGKA',
          'BUKIT TINGGI'
        ],
        'PERAK': [
          'IPOH',
          'TAIPING',
          'SITIAWAN',
          'SIMPANG EMPAT',
          'TELUK INTAN',
          'BATU GAJAH',
          'LUMUT',
          'KAMPUNG KOH',
          'KUALA KANGSAR',
          'SUNGAI SIPUT UTARA',
          'TAPAH',
          'BIDOR',
          'PARIT BUNTAR',
          'AYER TAWAR',
          'BAGAN SERAI',
          'TANJUNG MALIM',
          'LAWAN KUDA BAHARU',
          'PANTAI REMIS',
          'KAMPAR'
        ],
        'PERLIS': [
          'KANGAR',
          'KUALA PERLIS'
        ],
        'PULAU PINANG': [
          'BUKIT MERTAJAM',
          'GEORGETOWN',
          'SUNGAI ARA',
          'GELUGOR',
          'AYER ITAM',
          'BUTTERWORTH',
          'VAL D’OR',
          'PERAI',
          'NIBONG TEBAL',
          'PERMATANG KUCING',
          'TANJUNG TOKONG',
          'KEPALA BATAS',
          'TANJUNG BUNGAH',
          'JURU'
        ],
        'SABAH': [
          'KOTA KINABALU',
          'SANDAKAN',
          'TAWAU',
          'LAHAD DATU',
          'KENINGAU',
          'PUTATAN',
          'DONGGONGON',
          'SEMPORNA',
          'KUDAT',
          'KUNAK',
          'PAPAR',
          'RANAU',
          'BEAUFORT',
          'KINARUT',
          'KOTA BELUD'
        ],
        'SARAWAK': [
          'KUCHING',
          'MIRI',
          'SIBU',
          'BINTULU',
          'LIMBANG',
          'SARIKEI',
          'SRI AMAN',
          'KAPIT',
          'BATU DELAPAN BAZAAR',
          'KOTA SAMARAHAN'
        ],
        'SELANGOR': [
          'SUBANG JAYA',
          'KLANG',
          'AMPANG JAYA',
          'SHAH ALAM',
          'PETALING JAYA',
          'CHERAS',
          'KAJANG',
          'SELAYANG BARU',
          'RAWANG',
          'TAMAN GREENWOOD',
          'SEMENYIH',
          'BANTING',
          'BALAKONG',
          'GOMBAK SETIA',
          'KUALA SELANGOR',
          'SERENDAH',
          'BUKIT BERUNTUNG',
          'PENGKALAN KUNDANG',
          'JENJAROM',
          'SUNGAI BESAR',
          'BATU ARANG',
          'TANJUNG SEPAT',
          'KUANG',
          'KUALA KUBU BAHARU',
          'BATANG BERJUNTAI',
          'BANDAR BARU SALAK TINGGI',
          'SEKINCHAN',
          'SABAK',
          'TANJUNG KARANG',
          'BERANANG',
          'SUNGAI PELEK'
        ],
        'TERENGGANU': [
          'KUALA TERENGGANU',
          'CHUKAI',
          'DUNGUN',
          'KERTEH',
          'KUALA BERANG',
          'MARANG',
          'PAKA',
          'JERTEH'
        ],
        'WILAYAH PERSEKUTUAN': [
          'KUALA LUMPUR',
          'LABUAN',
          'PUTRAJAYA'
        ]
      }
    }
  },
  methods: {
    ...mapGetters({
      hasSession: 'auth/hasSession'
    }),
    ...mapActions({
      fetchCategories: 'licenseForm/fetchCategories',
      submitData: 'licenseForm/submitData'
    }),
    ...mapMutations({
      resetData: 'licenseForm/resetData',
      patchBusiness: 'licenseForm/patchBusiness',
      patchOwner: 'licenseForm/patchOwner'
    }),
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    icFormat (value) {
      if (!value) return ''
      const format = value.replace(/[-\s]/g, '')
      if (format.length > 8) return `${format.substr(0, 6)}-${format.substr(6, 2)}-${format.substr(8)}`
      if (format.length > 6) return `${format.substr(0, 6)}-${format.substr(6, 2)}`
      return format
    },
    onSameMailChanged ($event) {
      this.data.applicant.sameAsMail = $event
      if ($event) {
        this.data.applicant.residential_address = this.data.applicant.mailing_address
        this.data.applicant.postcode = this.data.applicant.mail_postcode
        this.data.applicant.state = this.data.applicant.mail_state
        this.data.applicant.city = this.data.applicant.mail_city
        return
      }
      this.data.applicant.residential_address = ''
      this.data.applicant.postcode = ''
      this.data.applicant.state = ''
      this.data.applicant.city = ''
    },
    addCharge () {
      if (!this.business_charge || Object.keys(this.business_charge).length === 0 || this.business_charge.formula_type === '') {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: i18n.t('business_charge_required'),
          visible: true
        })
        return
      }
      if (!this.business_charge.quantity || this.business_charge.quantity.toString().length === 0) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: i18n.t('quantity_required'),
          visible: true
        })
        return
      }
      if (this.business_charge.formula_type === 'area' && (!this.business_charge.width || this.business_charge.width.toString().length === 0)) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: i18n.t('width_required'),
          visible: true
        })
        return
      }
      if (this.business_charge.formula_type === 'area' && (!this.business_charge.length || this.business_charge.length.toString().length === 0)) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: i18n.t('length_required'),
          visible: true
        })
        return
      }
      this.business_charge.quantity = Number(this.business_charge.quantity)
      this.business_charge.width = Number(this.business_charge.width)
      this.business_charge.length = Number(this.business_charge.length)
      this.data.license.business_charges.unshift(this.business_charge)
      this.business_charge = { formula_type: '' }
    },
    removeCharge (index) {
      console.log(index)
      if (!index || index < 0) return
      this.data.license.business_charges.splice(index, 1)
    },
    calculateSubTotal (value) {
      if (value.formula_type !== 'area') {
        return parseInt(value.charge_rate) * Number(value.quantity)
      }
      return (parseInt(value.charge_rate) * Number(value.width) * Number(value.length)) * Number(value.quantity)
    },
    async onLicenseTypeChanged (value) {
      if (!value) return
      this.loading = true
      this.business_charge = { formula_type: '' }
      this.data.license = merge({}, DEFAULT_FORM_DATA.license, { type: this.data.license.type })
      try {
        if (value === 'license_hawker') {
          const { data } = await axios.get(`/licenses/${value}/indexes/business_zone`)
          this.business_zones = data.docs
        }
        if (value === 'license_market') {
          const { data } = await axios.get(`/licenses/${value}/indexes/market`)
          this.markets = data.docs
          this.business_zones = []
        }
        if (value === 'permit_billboard' || value === 'permit_open_space' || value === 'license_dog') {
          const { data } = await axios.get(`/licenses/${value}/indexes/business_type`)
          this.business_zones = data.docs
          this.data.license.business_type = this.business_zones[0]
          this.onBusinessTypeChanged(this.data.license.business_type)
        }
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: i18n.t('internal_server_error'),
          visible: true
        })
      } finally {
        this.loading = false
      }
    },
    async onOperationCategoryChanged (value) {
      if (!value) return
      this.loading = true
      try {
        const { data } = await axios.get(`/licenses/${this.data.license.type}/_design/search/_view/subcategory`, {
          params: {
            startkey: value._id,
            endkey: `${value._id}\uffff`,
            reduce: false,
            include_docs: true
          }
        })
        this.business_zones = data.reduce((result, item) => {
          if (item.categoryid === value._id && item.categories !== 'multiple') result.push(item)
          return result
        }, [])
        this.data.license.subcategory = ''
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: i18n.t('internal_server_error'),
          visible: true
        })
      } finally {
        this.loading = false
      }
    },
    async onOperationSubcategoryChanged (value) {
      this.data.license.quantity = ''
    },
    async onBusinessTypeChanged (value) {
      if (!value) return
      try {
        const { data } = await axios.get(`/licenses/${this.data.license.type}/indexes/business_charges`)
        this.business_charges = data.docs.filter(row => row.business_type === value._id)
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: i18n.t('internal_server_error'),
          visible: true
        })
      }
    },
    async onMarketChanged (value) {
      if (!value) return
      try {
        const { data } = await axios.get(`/licenses/license_market/indexes/market_zone`)
        this.business_zones = data.docs.filter(row => row.market_id === value._id)
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: i18n.t('internal_server_error'),
          visible: true
        })
      }
    },
    changeStep (currentForm, nextStep) {
      const valid = this.$refs[currentForm].validate()
      if (!valid) return
      if (currentForm === 'form1') {
        for (let key of Object.keys(this.data.applicant)) {
          if (key === 'sameAsMail' || key === 'gender' || key === 'marital_status') continue
          if (key === 'email') {
            this.data.applicant[key] = this.data.applicant[key].replace(/\s/g, '')
            continue
          }
          this.data.applicant[key] = this.data.applicant[key].trim().toUpperCase()
        }
      }
      this.stepnow = nextStep
    },
    submitForm: throttle(async function ($event) {
      this.loading = true
      const valid = this.$refs.form2.validate()
      if (!valid || ((this.data.license.type === 'permit_billboard' || this.data.license.type === 'permit_open_space') && this.data.license.business_charges.length === 0)) {
        if ((this.data.license.type === 'permit_billboard' || this.data.license.type === 'permit_open_space') && this.data.license.business_charges.length === 0) {
          this.$store.dispatch('snackbar/setSnackBar', {
            color: 'red',
            message: i18n.t('business_charges_required'),
            visible: true
          })
          this.loading = false
          return
        }
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: i18n.t('incomplete_form'),
          visible: true
        })
        this.loading = false
        return
      }
      for (let key of Object.keys(this.data.license)) {
        if (key === 'type' || key === 'sales_period' || typeof this.data.license[key] !== 'string') continue
        this.data.license[key] = this.data.license[key].trim().toUpperCase()
      }
      const response = await this.submitData(this.data)
      this.loading = false
      this.$router.push(`/license/preview/${btoa(response.id)}?type=${this.data.license.type}`)
    }, 1000)
  }
}
</script>

<style>
#activity {
  /* font-family: "Trebuchet MS", Arial, Helvetica, sans-serif; */
  border-collapse: collapse;
  width: 100%;
}

#activity td, #activity th {
  border: 1px solid #ddd;
  padding: 8px;
}

#activity tr:nth-child(even){background-color: #f2f2f2;}

#activity tr:hover {background-color: #ddd;}

#activity th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #4CAF50;
  color: white;
}
</style>
